export default __webpack_public_path__ + "static/media/ba1.f5704f01.jpg";